import React from 'react';
import { MessageCircle, Calendar } from 'lucide-react';
import { LINKS } from '../../data/mock';

const StickyFooter = () => {
  return (
    <>
      {/* Spacer to prevent content from being hidden behind fixed footer */}
      <div className="h-20 md:hidden"></div>
      
      {/* Sticky Footer - Mobile Only */}
      <div className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur-lg border-t border-gray-200 p-3 md:hidden z-50 shadow-[0_-4px_20px_rgba(0,0,0,0.1)]">
        <div className="flex items-center gap-3 max-w-lg mx-auto">
          {/* WhatsApp Button */}
          <a 
            href={LINKS.whatsapp} 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex-1 flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#128C7E] text-white py-4 px-4 rounded-xl font-bold text-sm transition-all duration-300 shadow-lg shadow-green-500/25"
          >
            <MessageCircle className="w-5 h-5" />
            WhatsApp
          </a>
          
          {/* Calendar Button */}
          <a 
            href={LINKS.calendar} 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex-[2] flex items-center justify-center gap-2 bg-[#007AFF] hover:bg-[#0056b3] text-white py-4 px-4 rounded-xl font-bold text-sm transition-all duration-300 shadow-lg shadow-blue-500/25"
          >
            <Calendar className="w-5 h-5" />
            Reservar Demo
          </a>
        </div>
      </div>
    </>
  );
};

export default StickyFooter;
